import React from "react";
import {Model} from '@morningtrain/react-resources';
import AuthReaction from "../reactions/AuthReaction";
import {Input, Hidden} from "@morningtrain/react-fields";
import PropTypes from "prop-types";

function ResetPasswordForm(props) {

    return (
        <Model namespace='auth' resourceName='password' submitoperationName='reset_password' operationName={'reset_password'} submittable={true} >
            <AuthReaction/>

            <div className="modal-header">
                Nulstil adgangskode
            </div>

            <div className="form-content">
                <Hidden name='token' value={props.token} required={true} />
                <Input name='email' type='email' label='Email' required={true} />
                <Input name='password' label='Angiv adgangskode'type='password' required={true} />
                <Input name='password_confirmation' label='Gentag adgangskode' type='password' required={true} />
            </div>

            <div className="modal-footer">
                <input type='submit'/>
            </div>
        </Model>
    );
}

ResetPasswordForm.defaultProps = {
    token: '',
};

ResetPasswordForm.propTypes = {
    token: PropTypes.string.isRequired,
};

export default ResetPasswordForm;
